import { Icon } from '@chakra-ui/react';
import memoize from 'fast-memoize';
import { createContext, ReactNode, useContext } from 'react';
import { AiOutlineDashboard } from 'react-icons/ai/index.js';

export type NavItem = {
  key: string;
  icon: ReactNode;
  to: string;
  title: ReactNode;
  className?: string;
};
export type MainNavState = {
  setNavItems: (navItems: NavItem[]) => void;
  navItems: readonly NavItem[];
};

const MainNavContext = createContext<MainNavState | undefined>(undefined);

const MainNavContextProvider = MainNavContext.Provider;

export const useMainNav = (): MainNavState => {
  const context = useContext(MainNavContext);
  if (!context) {
    throw new Error('MainNavContext was not found in the hierarchy');
  }
  return context;
};

export const buildDefaultHomeNavItem = memoize(
  (isSiderCollapsed: boolean, homePath: string, title: ReactNode = 'Home') => {
    return {
      key: `${homePath}-home`,
      icon: (
        <Icon
          as={AiOutlineDashboard}
          fontSize={isSiderCollapsed ? '2xl' : 'xl'}
        />
      ),
      to: homePath,
      title,
    };
  },
);

export { MainNavContextProvider as MainNavContext };
